"use client";

import { ComponentProps } from "react";
import Link from "next/link";

import useQuizLink from "./hooks/useQuizLink";

type Props = Omit<ComponentProps<typeof Link>, "href"> & {
    href: string;
};

/**
 * Inline text link to a quiz, for copy that can't call `useQuizLink` itself
 * (e.g. FAQ answers kept in data files). Button CTAs use `QuizCTA` instead.
 */
export const QuizTextLink = ({ href, ...linkProps }: Props) => {
    const { href: resolvedHref } = useQuizLink(href);

    return <Link {...linkProps} href={resolvedHref} />;
};
